import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';


export default function Datagrid({ rows, columns, hideFooter, pageChanged, checkBoxSelection, style, selectedData, handleCellClick,getRowId }) {
    // const styles = {
    //     '& .MuiDataGrid-columnHeaders': {
    //         backgroundColor: '#F9FAFB',
    //     },
    //     '& .MuiDataGrid-columnHeader': {
    //         backgroundColor: '#F9FAFB',
    //         color: '#5F6368',
    //         fontFamily: 'Roboto-Regular',
    //         fontStyle: 'normal',
    //         fontWeight: '400',
    //         fontSize: '1.2rem',
    //         lineHeight: '2rem',
    //         borderRight: '1px solid #EAECF0',
    //         // pointerEvents: 'none',
    //         padding: '0',
    //     },

    //     "& .MuiDataGrid-checkboxInput": {
    //         "& svg": {
    //             width: "2rem",
    //             height: "2rem",
    //             color: "#1570EF",
    //             backgroundColor: "#EFF8FF",
    //         },
    //     },
    //     '& .MuiDataGrid-columnHeader:last-child': {
    //         border: "none"
    //     },
    //     '& .MuiDataGrid-cell': {
    //         padding: '0 1.5rem !important',
    //         fontFamily: 'Roboto-Regular',
    //         fontStyle: 'normal',
    //         fontWeight: 400,
    //         fontSize: '1.4rem',
    //         lineHeight: '2rem',
    //         letterSpacing: '0.2px',
    //         color: '#3C4043',
    //         minHeight: style?.minHeight ? style?.minHeight : '53px !important',
    //         outline: 'none !important',
    //         cursor: 'pointer',
    //         width: '100%',
    //         whiteSpace: 'break-spaces !important'
    //     },
    //     '& .MuiDataGrid-row': {
    //         minHeight: style?.minHeight ? style?.minHeight : '53px !important'
    //     },
    //     '& .MuiDataGrid-columnHeaderTitle': {
    //         padding: '1.5rem',
    //     },
    //     '& .MuiDataGrid-cellContent': {
    //         // padding: '1.5rem',
    //         width: '100%',
    //         whiteSpace: 'break-spaces !important',
    //         textOverflow: 'unset !important'
    //     },
    //     '& .MuiDataGrid-columnSeparator': {
    //         display: 'none',
    //     },
    //     '& .MuiDataGrid-iconButtonContainer': {
    //         display: 'none',
    //     },
    //     '& .MuiTablePagination-displayedRows': {
    //         display: 'none',
    //     },
    //     '& .MuiDataGrid-main': {
    //         border: 'none',
    //         borderTop: '1px solid #EAECF0',
    //     },
    //     "& [title='Go to previous page']:after": {
    //         content: "'Previous'",
    //         marginLeft: "1rem",
    //     },
    //     "& [title='Go to next page']:before": {
    //         content: "'Next'",
    //         marginRight: "1rem",
    //     },
    //     "& [title='Go to previous page']": {
    //         border: "1px solid #EAECF0",
    //         borderRadius: "0.8rem",
    //         marginRight: "0.5rem",
    //     },
    //     "& [title='Go to next page']": {
    //         border: "1px solid #EAECF0",
    //         borderRadius: "0.8rem",
    //         marginRight: "0.5rem",
    //     },
    // };
    const styles = {
        "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
          outline: "none",
        },
        border: "1px solid #EAECF0 !important",
        fontWeight: "400",
        fontSize: "1.4rem",
        lineHeight: "2rem",
        color: "#667085",
        fontFamily: "Inter-Medium",
        borderRadius: "8px",
        '& div[data-colindex="1"]': {
          color: "#101828",
          fontWeight: "500",
        },
        "& .MuiDataGrid-virtualScrollerRenderZone": {
          "& .MuiDataGrid-row": {
            borderBottom: "1px solid #EAECF0",
            background: "#FFFFFF",
            /* Shadow/xl */
      
            // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
            borderRadius: "1rem",
      
            //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
            //   backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-row.Mui-selected:hover": {
            borderBottom: "1px solid #EAECF0",
            backgroundColor: "#FFFFFF",
            // "&:nth-of-type(2n+1)": {
            //   backgroundColor: "rgba(249, 250, 251, 1)",
            // },
          },
        },
        "& .MuiDataGrid-iconSeparator ": {
          display: "none",
        },
        "& .MuiDataGrid-columnHeader:hover": {
          "& .MuiDataGrid-menuIcon": {
            visibility: "hidden",
          },
        },
      
        "&  .MuiDataGrid-columnHeaders": {
          background: "#F9FAFB",
          /* Gray/200 */
          border: "1px solid #EAECF0",
          /* Shadow/xl */
          // boxShadow:
          //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
          // borderRadius: "8px",
      
          marginBottom: "1rem",
          borderBottom: "6px solid #EAECF0",
        },
        "& .MuiDataGrid-columnSeparator": {
          display: "none",
        },
        "& .MuiDataGrid-checkboxInput": {
          "& svg": {
            width: "2rem",
            height: "2rem",
            background: "#FFFFFF",
          },
        },
        // "& .MuiTablePagination-displayedRows": {
        //   display: "none",
        // },
        "& .MuiDataGrid-footerContainer": {
          "& .MuiTablePagination-displayedRows ": {
            display: "none",
          },
          "& .MuiDataGrid-selectedRowCount": {
            visibility: "hidden ",
          },
        },
        "&  [title='Sort']": {
          //visibility:"hidden",
          display: "none",
          cursor: "none",
        },
        "& [title='Go to previous page']": {
          borderRadius: "0",
          border: "1px solid #EAECF0",
          borderRadius: "0.8rem",
          marginRight: "0.5rem",
        },
        "& [title='Go to next page']": {
          borderRadius: "0",
          border: "1px solid #EAECF0",
          borderRadius: "0.8rem",
          marginRight: "0.5rem",
        },
        "& [title='Go to previous page']:after": {
          content: "'Previous'",
          marginLeft: "1rem",
        },
        "& [title='Go to next page']:before": {
          content: "'Next'",
          marginRight: "1rem",
        },
        "& .MuiDataGrid-columnHeader": {
          padding: "0 4rem",
      
          "&:focus": {
            outline: "none",
          },
        },
        "&  .MuiDataGrid-row ": {
          maxHeight: "72px !important",
          minHeight: "72px !important",
          cursor: "pointer",
        },
        "& .MuiDataGrid-cell": {
          padding: "0 4rem",
          minHeight: "72px !important",
          maxHeight: "72px !important",
          "&:focus": {
            outline: "none",
          },
        },
        "& .MuiButtonBase-root": {
          fontSize: "1.6rem",
        },
        "& .MuiDataGrid-cell:focus-within": {
          outline: "none !important",
        },
      };
    return (
        <Box style={{ flex: '1', height: '100% !important' }}>
            <DataGrid
                style={{ border: 'none' }}
                rows={rows}
                columns={columns}
                sx={[styles]}
                pageSize={10}
                hideFooter={hideFooter}
                disableColumnFilter={true}
                disableColumnMenu={true}
                disableColumnSelector={true}
                disableDensitySelector={true}
                disableSelectionOnClick={true}
                onCellClick={handleCellClick}
                checkboxSelection={checkBoxSelection}
                disableVirtualization={true}
                onSelectionModelChange={selectedData}
                rowsPerPageOptions={[10]}
                onPageChange={(e) => {
                    if (pageChanged) {
                        pageChanged(e)
                    }
                }}
                getRowId={getRowId}
            />
        </Box>
    );
}
